// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Usn8","importantInfo":"styles_importantInfo__3xTtu"};